function getSubdomain() {
    const parts = window.location.hostname.split(".");

    if (window.location.hostname === "localhost") {
        return "test13"; // при сборке на localhost руками вписываем тестовый стенд для запросов
    } else if (parts.length > 2) {
        return parts[0]; // при сборке на стенде автоматически стучимся на себя
    } else {
        return null;
    }
}

// собираемся на localhost?
const localDevelopment = process.env.NODE_ENV === "development" ? true : false;
// собираемся на test*.makclife.ru?
const testDevelopment = process.env.NODE_ENV !== "development" && window.location.origin !== "https://makclife.ru" ? true : false;

const subdomain = getSubdomain();
const baseURL = localDevelopment || testDevelopment ? `https://${subdomain}.makclife.ru/create/app.php` : "https://makclife.ru/create/app.php";
const esiaRedirectURL = localDevelopment || testDevelopment ? `https://${subdomain}.makclife.ru/create/final` : "https://makclife.ru/create/final";
const requestVersion = 4;

export {
    localDevelopment,
    testDevelopment,
    baseURL,
    esiaRedirectURL,
    requestVersion,
    subdomain
}
